import React from 'react';
import { useScreenRect } from 'app/views/components/footer/minimap/hooks/useScreenRect';
import { createRectWithHolePath } from 'app/views/components/svg/SVG';
export const MinimapFrame = (props) => {
    const { width, height, contentWidth, contentHeight: _ } = props;
    const clipRect = { x: 0, y: 0, width, height };
    const [screenRect] = useScreenRect(width, height, contentWidth, _);
    if (!screenRect) {
        return null;
    }
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", stroke: "none", opacity: "0.45", d: createRectWithHolePath(clipRect, screenRect) }),
        React.createElement("rect", { x: screenRect.x, y: screenRect.y, rx: "1", ry: "1", width: screenRect.width, height: screenRect.height, strokeWidth: "2", stroke: "#FFFFFF", strokeOpacity: "0.8", fill: "none" })));
};
